import React from "react";
import { Modal, Spin } from "antd";
import { ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import * as S from "./styles";

interface Company {
  id: string;
  companyName: string;
}

interface InvoiceItem {
  description?: string;
  quantity?: number;
  unitPrice?: number;
}

interface Invoice {
  invoiceNumber?: string;
  dateAdded?: string;
  updatedAt?: string;
  companyName?: string;
  companyAddress?: string;
  items?: InvoiceItem[];
  totalAmountDue?: number;
  pdfLink?: string;
}

interface InvoiceDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedInvoice: Invoice | null;
  selectedCompany: Company | null;
}

const InvoiceDetailModal: React.FC<InvoiceDetailModalProps> = ({
  isOpen,
  onClose,
  selectedInvoice,
  selectedCompany,
}) => {
  if (!selectedInvoice) return null;

  const pdfLink = selectedInvoice.pdfLink;

  const handleDownload = async () => {
    if (!pdfLink) return;

    try {
      // Fetch the PDF
      const response = await fetch(pdfLink);
      const blob = await response.blob();

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Invoice_${selectedInvoice.invoiceNumber || "document"}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Download failed:", error);
      // Fallback to opening in new tab if download fails
      window.open(pdfLink, "_blank");
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={900}
      closeIcon={null}
      wrapClassName="billing-invoices-modal-wrap"
      getContainer={false}
      styles={{
        body: { padding: 0, height: "80vh" },
      }}
      maskClosable={false}
    >
      <S.InvoiceDetailWrapper>
        {/* Header with Back and Download */}
        <S.InvoiceDetailHeader>
          <S.InvoiceDetailBackButton onClick={onClose}>
            <ArrowLeftOutlined />
            Back
          </S.InvoiceDetailBackButton>
          <S.InvoiceDetailDownloadButton onClick={handleDownload}>
            <DownloadOutlined />
            Download
          </S.InvoiceDetailDownloadButton>
        </S.InvoiceDetailHeader>

        {/* PDF Viewer */}
        {pdfLink ? (
          <S.PDFViewerContainer>
            <iframe
              src={pdfLink}
              title={`Invoice ${selectedInvoice.invoiceNumber || ""}`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </S.PDFViewerContainer>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "400px",
              color: "#888",
            }}
          >
            No PDF available for this invoice
          </div>
        )}
      </S.InvoiceDetailWrapper>
    </Modal>
  );
};

export default InvoiceDetailModal;
